import React from 'react';
import { Input } from "@shadcn-in-nx/ui/input";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@shadcn-in-nx/ui/tooltip";

// Valid intermediate states while typing: "", "-", "-1", "1.", "1.2", "1e", "1e-3", "1.2E+10"
const INT_PARTIAL = /^-?\d*$/;
const NUM_PARTIAL = /^-?\d*\.?\d*([eE][+-]?\d*)?$/;

export function NumberInput({
  value,
  onChange,
  onSave,
  onCancel,
  error,
  schema,
  autoFocus = true,
  className
}) {
  const isInteger = schema?.type === 'integer';
  const allowedPattern = isInteger ? INT_PARTIAL : NUM_PARTIAL;

  const commit = (raw) => {
    if (raw === '' || raw == null) return onSave(null);
    const n = Number(raw);
    if (!Number.isFinite(n)) return; // refuse to save invalid; keep edit mode open
    if (isInteger && !Number.isInteger(n)) return;
    onSave(n);
  };

  const handleChange = (e) => {
    const next = e.target.value;
    if (next === '' || allowedPattern.test(next)) onChange(next);
    // else: silently ignore the keystroke
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') commit(value);
    else if (e.key === 'Escape') onCancel();
  };

  const errorClass = error ? `${className} border-red-500 focus-visible:ring-red-500` : className;

  return (
    <div className='w-full h-full'>
      <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
            <Input
              type="text"
              value={value ?? ''}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              onBlur={() => commit(value)}
              autoFocus={autoFocus}
              min={schema?.minimum}
              max={schema?.maximum}
              step={isInteger ? 1 : schema?.multipleOf || 'any'}
              className={errorClass}
              inputMode={isInteger ? 'numeric' : 'decimal'}
            />
          </TooltipTrigger>
          {error && (
            <TooltipContent side="top" className="bg-red-500 text-white font-medium text-xs">
              <p>{error}</p>
            </TooltipContent>
          )}
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
